import React, { useState } from 'react'

import classnames from 'classnames'

import Note from '@tonaljs/note'
import { IconButton } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

const Circle = (props: {
	scale: any,
	onChange: (scale: any) => void,
	onOpen: () => void,
	open: boolean,
	isInset?: boolean,
	roots: string[],
	selectedRoot: string
}) => {

	const {
		scale,
		onChange,
		onOpen,
		open,
		isInset = false,
		roots,
		selectedRoot
	} = props

	
	const getLiEl = (root: string, selectedRoot: string, hidden: boolean) => {
		const { letter, acc, oct } = Note.get(root)

		return (
			<li onClick={hidden ? undefined : () => onChange(root)} className={classnames('key', { active: root === selectedRoot, sharp: acc, hidden })}>
				<a>
					<span>{letter + (acc === '#' ? '♯' : acc === 'b' ? '♭' : '')}</span>
				</a>
			</li>
		)
	}

	return (
		<div className={classnames('component csstransforms', { ['opened-nav']: open })} style={{
			zIndex: isInset ? 2 : 1,
			transform: /*'translate(-50%,-50%)' + */(isInset ? ' scale(0.6)' : ''),
			position: 'absolute',
			marginTop: isInset ? 238 : 0,
			marginLeft: isInset ? 1 : 0,
			height: isInset ? 0 : undefined
		}}>
			{isInset ? (
				<IconButton disableRipple onClick={onOpen} className='cn-button'>
					<AddIcon />
				</IconButton>
			) : undefined}

			<div className={classnames('cn-wrapper', { ['opened-nav']: open, inner: isInset })} id='cn-wrapper'>
				{/* <div className='cn-wrapper' id='cn-wrapper'> */}

				{isInset && <div className='inner-shadow'></div>}

				<ul id='keys'>
					{roots.map((root: string, i: number) => getLiEl(root, selectedRoot, i > 12))}
					{/* <li className='key active'><a href='#'><span>C</span></a></li>
					<li className='key'><a href='#'><span>G</span></a></li>
					<li className='key'><a href='#'><span>D</span></a></li>
					<li className='key'><a href='#'><span>A</span></a></li>
					<li className='key'><a href='#'><span>E</span></a></li>
					<li className='key'><a href='#'><span>B</span></a></li>
					<li className='key sharp'><a href='#'><span>F</span></a></li>
					<li className='key flat'><a href='#'><span>B</span></a></li>
					<li className='key flat'><a href='#'><span>E</span></a></li>
					<li className='key flat'><a href='#'><span>A</span></a></li>
					<li className='key flat'><a href='#'><span>D</span></a></li> */}
				</ul>
			</div>
			{/* <div id='cn-overlay' className='cn-overlay on-overlay'></div> */}
			{/* <div id='cn-overlay' className='cn-overlay'></div> */}
		</div>
	)
}

export default Circle
